/* global femcare, Swiper */

femcare.product.safetySection = {

    init: function () {
        this.$productSafety = $('.product-safety');

        if (this.$productSafety.length) {
            this.$layerImages = this.$productSafety.find('.product-layers__images img');
            this.initSliders();
        }
    },

    initSliders: function () {
        this.largeScreenSlider = new Swiper('.product-layers__slider--vertical', {
            spaceBetween: 10,
            slidesPerView: this.$layerImages.length,
            allowTouchMove: false,
            direction: 'vertical'
        });

        this.smallScreenSlider = new Swiper('.product-layers__slider--horizontal', {
            direction: this.getDirection(),
            autoplay: {
                delay: 5000
            },
            on: {
                resize: function () {
                    this.smallScreenSlider.changeDirection(this.getDirection());
                }.bind(this),
                realIndexChange: function (instance) {
                    var layerId = instance.slides[instance.realIndex].getAttribute('data-layer-id');
                    this.setLayerImage(layerId);
                }.bind(this)
            },
            breakpoints: {
                300: {
                    centeredSlides: true,
                    slidesPerView: 1.4,
                    spaceBetween: 15,
                    allowTouchMove: true
                }
            },
            thumbs: {
                swiper: this.largeScreenSlider,
                slideThumbActiveClass: 'active'
            }
        });
    },

    setLayerImage: function (layerId) {
        this.$layerImages.removeClass('active');
        $('#' + layerId).addClass('active');
    },

    getDirection: function () {
        var activeMediaquery = femcare.shared.util.getMediaqueryState();
        var isSmallScreen = activeMediaquery < femcare.shared.util.mediaqueries.medium;

        return isSmallScreen ? 'horizontal' : 'vertical';
    }
};